<template>
  <div class="saas-wrapper">
    <a-spin :spinning="loading" tip="Yükleniyor...">
      <div v-if="!loading && services.length === 0" class="empty-state">
        <CloudUploadOutlined style="font-size: 48px; color: #d9d9d9" />
        <p>Henüz SaaS servisi tanımlanmamış.</p>
      </div>

      <a-row
        v-else
        :gutter="[16, 16]"
        type="flex">
        <a-col
          v-for="service in services"
          :key="service.id"
          :xs="24"
          :sm="12"
          :md="6">
          <a
            v-if="service.link_type === 'external'"
            :href="service.link"
            target="_blank"
            rel="noopener noreferrer"
            class="card-link">
            <a-card hoverable class="card-item">
              <div class="card-icon-wrapper">
                <img
                  v-if="service.icon"
                  :src="portalUrl + service.icon"
                  :alt="service.name"
                  class="card-logo" />
                <CloudUploadOutlined
                  v-else
                  style="font-size: 32px; color: #1890ff" />
              </div>
              <h3 class="card-title">{{ service.name }}</h3>
              <p class="card-description">{{ service.description || '' }}</p>
            </a-card>
          </a>
          <div
            v-else
            class="card-link"
            @click="navigateInternal(service.link)"
            style="cursor: pointer">
            <a-card hoverable class="card-item">
              <div class="card-icon-wrapper">
                <img
                  v-if="service.icon"
                  :src="portalUrl + service.icon"
                  :alt="service.name"
                  class="card-logo" />
                <CloudUploadOutlined
                  v-else
                  style="font-size: 32px; color: #1890ff" />
              </div>
              <h3 class="card-title">{{ service.name }}</h3>
              <p class="card-description">{{ service.description || '' }}</p>
            </a-card>
          </div>
        </a-col>
      </a-row>
    </a-spin>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { CloudUploadOutlined } from '@ant-design/icons-vue'
import { useRouter } from 'vue-router'
import axios from 'axios'
import { csPortalUrl } from '@/utils/csPortal'

export default {
  name: 'SaasView',
  components: {
    CloudUploadOutlined
  },
  setup () {
    const router = useRouter()
    const loading = ref(false)
    const services = ref([])
    // cs-portal adresi config.json (csPortalUrl) / Docker CS_PORTAL_URL uzerinden gelir
    const CS_PORTAL_URL = csPortalUrl()

    const fetchServices = async () => {
      loading.value = true
      try {
        const response = await axios.get(`${CS_PORTAL_URL}/api/saas/public`)
        services.value = response.data
      } catch (error) {
        console.error('SaaS servisleri yüklenemedi:', error)
      } finally {
        loading.value = false
      }
    }

    const navigateInternal = (link) => {
      try {
        const url = new URL(link)
        const path = url.hash ? url.hash.replace('#', '') : url.pathname
        router.push(path)
      } catch {
        router.push(link)
      }
    }

    onMounted(fetchServices)

    return { services, loading, navigateInternal, portalUrl: CS_PORTAL_URL }
  }
}
</script>

<style scoped>
.saas-wrapper {
  padding: 0;
}
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #8c8c8c;
}
.empty-state p {
  margin-top: 12px;
  font-size: 14px;
}
.card-link {
  display: block;
  text-decoration: none;
  color: inherit;
  height: 100%;
}
.card-item {
  height: 100%;
}
.card-icon-wrapper {
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}
.card-logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.card-title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a2e;
  margin: 0 0 10px 0;
}
.card-description {
  font-size: 13px;
  color: #8c8c8c;
  line-height: 1.6;
  margin: 0;
}
</style>
